import * as React from 'react';
import { getToken } from '../../services/config/AdalConfig';
import StandardSummary from './StandardSummary';

export interface ITestViewStandardSummaryProps {
}

export default class TestViewStandardSummary extends React.Component<ITestViewStandardSummaryProps> {
  componentDidMount = () => {
    document.querySelectorAll('style,link[rel="stylesheet"]').forEach((item) => {
      //console.log(item.localName, item.baseURI);
      if (!item.textContent.includes("StandardSummaryCss")) {
        item.remove()
      }
    })

  }

  public render() {
    return (
      <div>
        <StandardSummary
          ssRequest={{ db: 1, standardSummaryTypeId: 3, month: -1, quarter: -1, year: 2021 }}
          partId={null}
          apiToken={`Bearer ${getToken()}`}
        />
      </div>
    );
  }
}
